import { Serializable } from '@/models/core/serializable';
import { Student } from '@/models/student/student';
// import { Student } from './student';

export class SchoolGroupStudent implements Serializable<SchoolGroupStudent> {
  groupID: number;
  groupName: string;
  studentList: Student[] = [];

  deserialize(input: any): SchoolGroupStudent {
    this.groupID = input.groupID;
    this.groupName = input.groupName;
    if (input.studentList && input.studentList.length > 0) {
      this.studentList = input.studentList.map((student: Student) => new Student().deserialize(student));
    }
    return this;
  }
}
